import { render, staticRenderFns } from "./DateConfirmField.vue?vue&type=template&id=1b8b9b7f"
import script from "./DateConfirmField.vue?vue&type=script&lang=js"
export * from "./DateConfirmField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports